import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AdminDashboard from "@/pages/AdminDashboard";
import StaffConsole from "@/pages/StaffConsole";
import StaffAdminGate from "@/components/StaffAdminGate";
import { useAdminRole } from "@/hooks/useAdminRole";

function AdminHome() {
  const { isAdmin } = useAdminRole();
  return isAdmin ? <AdminDashboard /> : <StaffConsole />;
}

export const Route = createFileRoute("/admin/")({
  head: () => seoHead("/admin/"),
  component: () => (
    <StaffAdminGate><AdminHome /></StaffAdminGate>
  ),
});
